module.exports = __webpack_public_path__ + "media/assets/images/tenant-portal-tips/warm-water1-cb50a1599b23b6069db7e80984bbeb54.jpg";